import React from 'react';
import BaseSimplePage from "../BaseSimplePage/BaseSimplePage";
import CitiesItemForm from "./CitiesItemForm";
import CitiesItemBrowser from "./CitiesItemBrowser";

const CitiesSubPage = ({isAddSubMode}) => {

    return (
        <BaseSimplePage
            isAddSubMode={isAddSubMode}
            modeApiName1="city"
            modeApiName2="cities"
            ItemFormComponent={CitiesItemForm}
            ItemBrowserComponent={CitiesItemBrowser}
        />
    );
};

export default CitiesSubPage;